export default from './Table';
